import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { exportLeads, fetchLeadData } from '../../store/LeadSlice';
import { fetchPlatforms } from '../../store/platformSlice';
import { toast } from 'react-toastify';
import { CloseRounded } from '@mui/icons-material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import EmailIcon from '@mui/icons-material/Email';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { fetchContacts } from '../../store/contactSlice';

export default function ContactLeadExport({ setPage, getContacts, selectedDomain, selectedClient, ordering, setSelected, numSelected, selected, open, setOpen, currentLandingPages, setCurrentLandingPages, isFilter, tabValue, setSelectedClient, setSelectedDomain, handleSelectAllClick, setToggleCallApi }) {
    const dispatch = useDispatch();

    const [availableDataCount, setavailableDataCount] = useState(10)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [exportVarient, setExportVarient] = useState(null)
    const clients = useSelector((state) => state.clientReducer.clientList)
    const domains = useSelector((state) => state.domainReducer.domainList)
    const landingPages = useSelector((state) => state.landingPageReducer.landingPages)

    const validationSchema = Yup.object({
        client_id: !isFilter && !tabValue ?
            Yup.string().required("Client is required")
            : Yup.string(),
        num_leads: !tabValue ?
            Yup.number().required("Number of leads is required").min(1, "The Minimum number of leads should be greater than 0.").max(1000, "The number should not be greater then 1000") : Yup.number(),
    });

    const handleExportLeads = () => {
        let payload;
        if (numSelected > 0) {
            payload = {
                client_id: formik.values.client_id,
                leads_uuids: selected,
                export_type: exportVarient,
            }
        } else {
            payload = {
                client_id: formik?.values?.client_id,
                landing_page: currentLandingPages,
                num_leads: availableDataCount,
            };
        }
        // let payload;
        // if (numSelected > 0) {
        //     payload = {
        //         client_id: formik.values.client_id,
        //         leads_uuids: selected,
        //         export_type: exportVarient,
        //     }
        // } else {
        //     payload = {
        //         client_id: formik?.values?.client_id,
        //         landing_page: currentLandingPages,
        //         num_leads: availableDataCount,
        //     };
        // }
        exportLeads(payload)
    }
    const initialValues = {
        landing_page: [],
        client_id: "",
        num_leads: 10,

    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.landing_page = currentLandingPages
            console.log("values.client_id", values.client_id);

            if (isFilter) {
                if (!values.client_id) {
                    console.log("client id not found",);

                    setSelectedClient(values.client_id)
                    setSelectedClient(clients.map((ele) => ele.id).join(","))
                } else {
                    setSelectedClient(values.client_id)
                    setToggleCallApi(prev => !prev)
                }
                setPage(0)
                setSelectedDomain(values.landing_page)
            } else {

                if (numSelected > 0) {

                    exportContactLeads({
                        client_id: values.client_id,
                        leads_uuids: selected,
                    })
                } else {
                    exportContactLeads({
                        client_id: values.client_id,
                        landing_page: currentLandingPages,
                        num_leads: values.num_leads,
                    })
                }
            }
            setOpen(false);
            // setSelected([])
            formik.resetForm({ values: { ...initialValues } });
        },
    });

    const exportContactLeads = async (payload) => {
        const token = localStorage.getItem('userAuthToken');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/leads/contact/export_leads?export_type=${exportVarient}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                if (exportVarient === "download") {

                    const blob = await response.blob();
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = 'exported_leads.xlsx';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    toast.success("Leads shared over email successfully.")
                }
                getContacts().then(() => {
                    setSelected([])
                })
                // setToggleCallApi(prev => !prev)

            } else {
                const errorData = await response.json();
                if (errorData.status_code === 400) {
                    toast.error(errorData?.details || "Failed to export leads!");
                }
                if (errorData.status_code === 409) {
                    setDialogOpen(true)
                    setavailableDataCount(errorData?.data?.available_data_count)
                }
            }
        } catch (error) {
            console.log("error in export", error);

        }
    }
    useEffect(() => {
        if (formik.errors && Object.keys(formik.errors).length > 0) {
            formik.resetForm();
        }
        if (selectedDomain) {
            setCurrentLandingPages(selectedDomain)
        }

    }, [open])

    useEffect(() => {
        formik.setFieldValue('client_id', "")
    }, [tabValue, isFilter])


    return (
        <Box className="position-relative h-100">
            <Dialog
                open={dialogOpen}
                onClose={() => { setDialogOpen(false) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Confirmation
                            </Typography>
                            <Divider />
                            <Typography variant="body1" className='mt-3' gutterBottom>
                                {`Only ${availableDataCount} unsold Facebook leads available, requested ${formik?.values?.num_leads} Are you want Export it ?`}
                            </Typography>
                        </Box>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDialogOpen(false) }} variant="outlined" color='primary'  >No</Button>
                    <Button onClick={() => { handleExportLeads(); setDialogOpen(false) }} variant="contained" color='primary' type="submit">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <form onSubmit={formik.handleSubmit} >
                <Box className="d-flex justify-content-between p-3">
                    <Typography variant="h6" gutterBottom >
                        {isFilter ? "Apply Filter" : "Export Leads"}
                    </Typography>
                    <Button variant="outlined" className='mb-2' startIcon={<RestartAltIcon color='primary' />}
                        onClick={() => {
                            const data = {
                                page: 1,
                                page_size: 10,
                            }
                            dispatch(fetchContacts()).then((res) => {
                                console.log("leads res dara", res);

                            }).catch((err) => {
                                console.log("error in fetching lead data", err);
                            })
                            formik.resetForm()
                            setOpen(false)
                            setPage(0)
                            setSelectedClient(0)
                            setSelectedDomain([])
                            setCurrentLandingPages([])
                        }}
                    > Clear Filters</Button>
                </Box>
                <Divider />
                <div className='role-form-scroller px-3'>

                    {!isFilter || tabValue ? <FormControl fullWidth className='mt-3 min-with-select'
                        error={formik.touched.client_id && Boolean(formik.errors.client_id)}
                        required={!tabValue}
                    >
                        <InputLabel id="client_id">Client</InputLabel>
                        <Select
                            fullWidth
                            labelId="client_id"
                            id="client_id"
                            name='client_id'
                            label="Client"
                            MenuProps={{
                                PaperProps: {
                                    className: "mui-select-menu",
                                }
                            }}
                            value={formik.values?.client_id}
                            onChange={formik.handleChange}
                            endAdornment={
                                formik?.values?.client_id ? (
                                    <IconButton
                                        size="small"
                                        className='mr-4'
                                        onClick={() => formik.setFieldValue('client_id', '')}
                                        onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                    >
                                        <CloseRounded />
                                    </IconButton>
                                ) : null
                            }
                            onBlur={formik.handleBlur}
                            error={formik.touched.client_id && Boolean(formik.errors.client_id)}
                            helperText={formik.touched.client_id && formik.errors.client_id}
                        >

                            {tabValue === 1 && <MenuItem value={0}>All</MenuItem>}
                            {(!clients || clients?.length === 0) && (
                                <MenuItem disabled color="primary">
                                    No Client found.
                                </MenuItem>
                            )}
                            {clients?.length && clients?.map((ele) => <MenuItem value={ele.id}>{ele.email}</MenuItem>)}
                        </Select>
                        {formik.touched.client_id && formik.errors.client_id && (
                            <FormHelperText className='text-danger'>{formik.errors.client_id}</FormHelperText>
                        )}
                    </FormControl> : <></>}
                    {(isFilter || numSelected === 0) && <>
                        {<FormControl className="mt-3 min-with-select" fullWidth>
                            <InputLabel id="landing_page">Domain</InputLabel>
                            <Select
                                labelId="landing_page"
                                id="landing_page"
                                multiple
                                name="landing_page"
                                label="Domain"
                                value={currentLandingPages}
                                onChange={(event) => {
                                    setCurrentLandingPages(event.target?.value)
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                renderValue={(selected) => {
                                    return (<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {currentLandingPages?.map((id) => {
                                            const selectedIndustry = domains.find((ele) => ele?.id === id);
                                            return (
                                                <Chip
                                                    className="role-permission mr-2"
                                                    key={id}
                                                    label={selectedIndustry?.route}
                                                    onMouseDown={(event) => {
                                                        event.stopPropagation();
                                                    }}
                                                    onDelete={(event) => {
                                                        const updatedData = currentLandingPages.filter((item) => item !== id);
                                                        console.log("on deletee called", updatedData);
                                                        setCurrentLandingPages(updatedData)
                                                    }}
                                                />
                                            );
                                        })}
                                    </Box>)
                                }}
                            >
                                {(!domains || domains?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Domain found.
                                    </MenuItem>
                                )}
                                {domains?.length &&
                                    domains.map((ele) => {
                                        return (<MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox
                                                checked={currentLandingPages.includes(ele.id)}
                                            />
                                            <ListItemText primary={ele.route} />
                                        </MenuItem>)
                                    })}
                            </Select>
                        </FormControl>}
                        {!isFilter && <TextField
                            fullWidth
                            required
                            type='number'
                            id="num_leads"
                            name="num_leads"
                            label="Per Platform Lead Count"
                            margin="normal"
                            variant="outlined"
                            className='mt-3 mb-0'
                            value={formik?.values?.num_leads}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.num_leads && Boolean(formik.errors.num_leads)}
                            helperText={formik.touched.num_leads && formik.errors.num_leads}
                        />}
                    </>}
                </div>
                <Box className="drawer-footer m-3">
                    {numSelected > 0 && !isFilter && (
                        <Box className="mb-3 p-2" style={{ backgroundColor: "#fafdf3", borderRadius: "5px", border: "1px solid #ddd" }}>
                            <Typography variant="body2" color="textSecondary">
                                To export all the filtered leads, please remove the selection of specific leads. <span style={{ color: '#425e0ae8', fontWeight: '600', textDecoration: 'underline', marginLeft: '5px', cursor: 'pointer' }} onClick={handleSelectAllClick}>Remove selection</span>
                            </Typography>
                        </Box>
                    )}
                    <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpen(false)}
                        className="mt-2 mr-2"
                    >
                        Cancel
                    </Button>
                    {!isFilter ?
                        <>
                            <Button
                                type="submit"
                                variant="contained"
                                className="mt-2 mr-2"
                                onClick={() => {
                                    setExportVarient('download')
                                }}
                                startIcon={<SystemUpdateAltIcon color='white' />}
                                disabled={!(formik.dirty && formik.isValid)}


                            >
                                Download
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setExportVarient('share')
                                }}
                                className="mt-2"
                                startIcon={<EmailIcon />}
                                disabled={!(formik.dirty && formik.isValid)}

                            >
                                Send Email
                            </Button>
                        </> :
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={tabValue === 0 ? currentLandingPages?.length === 0 : (formik.values.client_id === '' && currentLandingPages?.length === 0)} className="mt-2"
                            startIcon={<FilterAltIcon />}
                        >
                            Apply
                        </Button>}
                </Box>
            </form>
        </Box>
    );
}